import React, { useEffect, useState } from 'react';
import '../common/cardView.scss';
import './quizCard.scss';
import { useHistory } from "react-router-dom";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { useTranslations, useQuizButtonStatus, useStyles } from "examsbook-react-sdk/custom-hooks";
import { ReactComponent as TestImg } from "../../assets/images/evaluationTestIcon.svg";
import { Box, Button, Typography } from '@material-ui/core';
import { useTheme } from '../../constants/themeProvider';
import { ReactComponent as TryImage } from "../../assets/images/tryImage.svg";
import OverlayButton from '../../constants/OverlayButton';
import { toggleBottomBar } from 'examsbook-react-sdk/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

function QuizCard(props) {
    const { quizData, singleTestSeriesLoading, onQuizCardClick, course_id, progressPercent, courseName, attemptsRemaining, quizTotalAttempts, isUserCertified, certificationToggle } = props;
    const t = useTranslations();
    const history = useHistory();
    const [isModalVisible, setModalVisible] = useState(false);
    const { disabled, action } = useQuizButtonStatus(quizData);
    const bestScore = quizData.quizAttempts !== 0 ? Math.max(...quizData.testScore) : 0
    const theme = useTheme();
    const location = useLocation();

    const styles = {
        startBtn: {
            textTransform: 'capitalize',
            fontWeight: '600',
            "&:hover": {
              background: "#0c3450e0 !important",
            }
        },
        buttonDisabled: {
            opacity: "0.4",
            cursor: "not-allowed",
          },
        viewResult: {
            textTransform: 'capitalize',
            fontWeight: '600',
            background: 'transparent !important',
            border: `1px solid ${theme?.primaryColor}`,
            borderRadius: '4px',
            color: `${theme?.primaryColor}`,
            "&:hover": {
                background: "#0000000a !important",
              }
        }
    }
    const classes = useStyles(styles)();
    const dispatch = useDispatch();
    const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;

    const hideModal = () => {
        setModalVisible(false);
    };

    useEffect(() => {
        if(showInstructions) {
            handleClickAction();
        }
    }, [showInstructions]);

    function handleClickAction() {
        if (action === 'PAYMENT') {
            history.push("/payments");
        }
        else if (action === 'START') {
            if (attemptsRemaining >=  quizTotalAttempts) {
                setModalVisible(true);
            }
            else {
                props?.showInstructionScreen();
            onQuizCardClick(quizData.testId);
            reactGaEvent("Live Test", "Start Quiz");
            dispatch(toggleBottomBar(true));
            }
        } else {
            history.push('/tests/result/' + quizData._id);
        }
    }

    const QuizSucessful = () => {
        return (
            <Box className='modal-bg'>
                <Box className='modal-content' onClick={(e) => e.stopPropagation()}>
                    <Box className='modal-heading'>
                        <h2 className='modal-heading-text'>{t('You have exceeded the number of quiz attempts!')}</h2>
                        <Box className='ok-align'>
                            <Box onClick={hideModal}
                                className='ok-btn'>{t('Ok')}</Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    };

    const showResult = ()=>{
        history.push(`/reports/${quizData?.testId?.slug}/${course_id}`,  {courseId:course_id, slug:quizData?.testId?.slug, pageType: "Instruction", courseName: courseName, redirectFromViewResult: true  })
      }

    function renderList() {
        return (
            <>
                <Box className='certificate-box' disabled={disabled}>
                    <Box className='scrollable-container'>
                        <Box>
                            {props?.quizData?.quizAttempts === 0 && progressPercent < quizData?.testId?.EvaluationUnlockPercent && <Typography className='certifiedText'>*{t('Complete')} {quizData?.testId?.EvaluationUnlockPercent}% {t('of the course to unlock the evaluation test')}</Typography>}
                            {props?.quizData?.quizAttempts === 0 && progressPercent >= quizData?.testId?.EvaluationUnlockPercent && <Typography className='certifiedText'>*{t('Your evaluation test is unlocked, you can now attempt the evaluation test.')}</Typography>}
                            {props?.quizData?.quizAttempts > 0 && isUserCertified && certificationToggle && <Typography className='certifiedTextPassed'>✅ {t('You’ve successfully passed the evaluation test. Great job!')}</Typography>}
                            {props?.quizData?.quizAttempts > 0 && !isUserCertified && certificationToggle && <Typography className='certifiedText'>❌ {t('You did not pass the evaluation test. Review the course content and reattempt the test.')}</Typography>}
                            <Box className="certificate-text-div">
                                <Box className='certificate-main-div'>
                                    <Box className="certificate-default-img-container"><TestImg className='certificate-img'/></Box>
                                    <Box className='live-text'>
                                        <p className='genus-text'>{quizData.testId.name}</p>
                                        <p className='best-score'>{`${t("Best_Score")}: ${bestScore}/${quizData.testId.mark}`}</p>
                                    </Box>
                                </Box>
                                <Box className='completion-box'>
                                    <TryImage style={{marginRight: '-7px'}}/>
                                    <Typography variant='inherit' className='completion' style={{color: `${theme?.primaryColor}`}}>{`${quizData?.quizAttempts}/${quizTotalAttempts}`} {t("Attempt")}</Typography>
                                    <OverlayButton
                                        onClick={handleClickAction}
                                        title={t("Get Started")}
                                        classStyleHeading={`${classes.startBtn} ${progressPercent < quizData?.testId?.EvaluationUnlockPercent ? classes.buttonDisabled : ""}`}
                                        disabled={progressPercent < quizData?.testId?.EvaluationUnlockPercent}
                                    />
                                    {props?.quizData?.quizAttempts > 0 && <Button onClick={showResult} className={classes.viewResult}>{t("view_result")}</Button>}
                                </Box>
                            </Box>
                            <Box className="certificate-text-div mobile-certificate-text-div">
                                <Box className='certificate-main-div'>
                                    <TestImg className='certificate-img'/>
                                    <Box className='live-text'>
                                        <p className='genus-text'>{quizData.testId.name}</p>
                                        <p className='best-score'>{`${t('Best_Score')}: ${bestScore}/${quizData.testId.mark}`}</p>
                                    </Box>
                                </Box>
                                <Box className='completion-box'>
                                    <TryImage style={{marginRight: '-7px'}}/>
                                    <Typography variant='inherit' className='completion' style={{color: `${theme?.primaryColor}`}}>{`${quizData?.quizAttempts}/${quizTotalAttempts}`} {t("Attempt")}</Typography>
                                </Box>
                                <Box className="btn-container">
                                    <OverlayButton
                                        onClick={handleClickAction}
                                        title={t("Get Started")}
                                        classStyleHeading={`${classes.startBtn} ${progressPercent < quizData?.testId?.EvaluationUnlockPercent ? classes.buttonDisabled : ""}`}
                                        disabled={progressPercent < quizData?.testId?.EvaluationUnlockPercent}
                                    />
                                    {props?.quizData?.quizAttempts > 0 && <Button onClick={showResult} className={classes.viewResult}>{t("view_result")}</Button>}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                {
                    isModalVisible &&
                    <QuizSucessful />
                }
            </>
        );
    }

    function renderLoader() {
        //we will show four cards to fill this space.
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
            {
                !singleTestSeriesLoading ? renderList() : renderLoader()
            }
        </React.Fragment>
    );
}

export default QuizCard;
